import { createContext, Dispatch, SetStateAction, useContext, useEffect, useState } from "react";

export interface ShowOnboardingContextType {
    showOnboarding: string;
    setShowOnboarding: Dispatch<SetStateAction<string>>;
    hasOfferCreated: string;
    setHasOfferCreated: Dispatch<SetStateAction<string>>;
    offerWorkingProperly: string;
    setOfferWorkingProperly: Dispatch<SetStateAction<string>>;
    isExtensionEnableOnboarding: string;
    setIsExtensionEnableOnboarding: Dispatch<SetStateAction<string>>;
}

const ShowOnboardingContext = createContext<ShowOnboardingContextType | undefined>(undefined);

export const useShowOnboarding = () => {
    const context = useContext(ShowOnboardingContext);
    if (!context) {
        throw new Error("useShowOnboarding must be used within a ShowOnboardingProvider");
    }
    return context;
};

export const ShowOnboardingProvider = ({ children }: any) => {
    const [showOnboarding, setShowOnboarding] = useState(sessionStorage.getItem("showOnboarding") || "1");

    useEffect(() => {
        sessionStorage.setItem("showOnboarding", showOnboarding);
    }, [showOnboarding]);

    const [hasOfferCreated, setHasOfferCreated] = useState(localStorage.getItem("hasOfferCreated") || "0");
    useEffect(() => {
        localStorage.setItem("hasOfferCreated", hasOfferCreated);
    }, [hasOfferCreated]);

    const [offerWorkingProperly, setOfferWorkingProperly] = useState(
        localStorage.getItem("offerWorkingProperly") || "0",
    );
    useEffect(() => {
        localStorage.setItem("offerWorkingProperly", offerWorkingProperly);
    }, [offerWorkingProperly]);

    const [isExtensionEnableOnboarding, setIsExtensionEnableOnboarding] = useState(
        localStorage.getItem("isExtensionEnableOnboarding") || "0",
    );
    useEffect(() => {
        localStorage.setItem("isExtensionEnableOnboarding", isExtensionEnableOnboarding);
    }, [isExtensionEnableOnboarding]);

    return (
        <ShowOnboardingContext.Provider
            value={{
                showOnboarding,
                setShowOnboarding,
                // currentOnboardingScreen,
                // setCurrentOnboardingScreen,
                hasOfferCreated,
                setHasOfferCreated,
                offerWorkingProperly,
                setOfferWorkingProperly,
                isExtensionEnableOnboarding,
                setIsExtensionEnableOnboarding,
            }}
        >
            {children}
        </ShowOnboardingContext.Provider>
    );
};
